import { SetupState } from "./types";

export function getDefaultState(): SetupState {
    return {
        allFeatures: [],
        actionPlans: [],
        responseAlarmTypes: [],
        currentAreas: null
    }
}